import { acquireSharedSocket, releaseSharedSocket } from "./socketManager";

function connectToSocket({ userId, scope, component, companyId, onDisconnect }) {
	try {
		const socket = acquireSharedSocket({
			userId,
			companyId: companyId != null && companyId !== "" ? String(companyId) : "",
		});
		if (!socket) return undefined;

		if (typeof onDisconnect === "function") {
			socket.on("disconnect", onDisconnect);
		}

		return socket;
	} catch (err) {
		console.error(err);
		return undefined;
	}
}

export { releaseSharedSocket };
export default connectToSocket;
